'use strict';

const _ = require('lodash');
const $ = require('jquery');

const utils = module.exports;

const space = encodeURIComponent(' ');

/**
 * Private translator function for parse utility.
 * @param val
 */
function parseTranslator(val) {
    // NOTE must be tested before numbers as it comes out 0
    if (val === '') {
        return undefined;
    }

    // NOTE must be tested before numbers as it comes out 0
    if (val === null) {
        return val;
    }

    // NOTE must be tested before Number constructor because
    // Number(["123']) => 123
    if (_.isArray(val)) {
        return _.map(val, parseTranslator);
    }

    const intVal = Number(val);
    if (!_.isNaN(intVal)) {
        return intVal;
    }

    if (val === 'true') {
        return true;
    }

    if (val === 'false') {
        return false;
    }

    if (_.isObject(val)) {
        return _.mapValues(val, parseTranslator);
    }

    return val;
}

/**
 * Parses an object containing parameters of key and value, coercing value conditionally.
 * This is useful for translating route and query string parameters.
 * @param {Object} params
 * @returns {Object}
 */
utils.parse = function (params) {
    return _.mapValues(params, parseTranslator);
};

/**
 * Turns things into parameters suitable for URLs.
 * @returns {string}
 */
utils.param = function () {

    const params = $.param.apply($, arguments);
    const result = params.replace(/\+/ig, space);
    return result;
};

/**
 * Translates a query string into parameters. Each parameter name and value
 * will be passed through `decodeURIComponent`.
 * @param queryString
 * @returns {*}
 */
utils.queryStringToParams = function (queryString) {

    if (!queryString) {
        return {};
    }

    const keyValuePairs = queryString.split('&');

    const result = _.reduce(keyValuePairs, function (memo, param) {

        const parts = param.split('=');
        let name = decodeURIComponent(_.head(parts));
        const paramValue = decodeURIComponent(_.last(parts));
        const value = paramValue;

        // NOTE we need to see if the encoded parameter is a property of an
        // object, or an item in an array, and we can do that by looking for
        // forms like "obj[prop]" and "arr[]" in the name, more examples can
        // be found here: http://api.jquery.com/jquery.param/
        const match = name.match(/\[([^\]]*)?\]/i);

        if (match) {
            const isArray = (name.substring(name.length - 2, name.length) === '[]');

            if (isArray) {
                name = name.substring(0, name.length - 2);

                if (!_.get(memo, name)) {
                    _.set(memo, name, []);
                }

                const arr = _.get(memo, name);
                arr.push(value);
            } else {
                _.set(memo, name, value);
            }
        } else {

            memo[name] = value;
        }

        return memo;
    }, {});

    return result;
};

/**
 * Translates parameters into a query string.
 * @param params
 * @returns {*}
 */
utils.paramsToQueryString = function (params) {
    return utils.param(params);
};
